import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkAuth = () => {
            const userStr = localStorage.getItem("user");
            if (!userStr) {
                navigate("/login", { replace: true });
                return;
            }
            try {
                const user = JSON.parse(userStr);
                if (user.role !== "ADMIN") {
                    navigate("/", { replace: true });
                }
            } catch (e) {
                localStorage.removeItem("user");
                navigate("/login", { replace: true });
            }
        };
        checkAuth();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
    };

    const navItems = [
        { label: "Dashboard", path: "/admin", icon: "📊" },
        { label: "Team", path: "/admin/team", icon: "🛡️" },
        { label: "Customers", path: "/admin/customers", icon: "👥" },
        { label: "Bookings", path: "/admin/bookings", icon: "📅" },
    ];

    return (
        <div className="admin-layout">
            {/* Sidebar */}
            <aside className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <h2 className="admin-sidebar-title">Glaminant Admin</h2>
                </div>

                <nav className="admin-nav">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`admin-nav-item ${isActive ? 'active' : ''}`}
                            >
                                <span className="admin-nav-icon">{item.icon}</span>
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div className="admin-sidebar-footer">
                    <button onClick={handleLogout} className="admin-logout-btn">
                        <span className="admin-nav-icon">🚪</span>
                        <span>Logout</span>
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
